export const PHASES = {
  RESOLVING: 'resolving',
  ESTIMATING: 'estimating',
  COMPLETE: 'complete'
};

export const BATCH_SIZE = 6;
